export function getTenantHost() {
  if (typeof window === "undefined" || !window.location?.host) {
    return null;
  }

  const host = String(window.location.host || "")
    .trim()
    .toLowerCase();
  return host || null;
}

export function getTenantHostHeader() {
  const host = getTenantHost();
  return host ? { "X-Tenant-Host": host } : {};
}
